import React from 'react'
import AimHeader from 'components/AimHeader'
import AimFooter from 'components/AimFooter'
// FontAwesomeのcssを先読みし一瞬でかくなるのを防ぐ
import '@fortawesome/fontawesome-svg-core/styles.css'
import { config } from '@fortawesome/fontawesome-svg-core'
config.autoAddCss = false

const SeminarLayout = ({ children }) => {
  return (
    <div className="seminarLayout">
      <AimHeader type="seminar" />
      <main className="seminarLayout__main">{children}</main>
      <AimFooter type="default" />
    </div>
  )
}

export default SeminarLayout
